import {createModel} from "~~/package/utils/ModelUtil";
import {HomeExploreCardModel} from "~~/package/mapper/home/model/HomeExploreCardModel";
import {BlogDataModel} from "~~/package/mapper/home/model/BlogDataModel";
import {EventDataModel} from "~~/package/mapper/home/model/EventDataModel";

export class ArticleModel extends HomeExploreCardModel {
    constructor(
        public data: string = "",
        public blogData: BlogDataModel = new BlogDataModel(),
        public eventData: EventDataModel = new EventDataModel(),
        // 이 글이 작성된 언어(예: "EN", "KO"). 글마다 한 언어로만 작성되므로, 상세 페이지에서
        // URL의 /en, /ko 접두어가 이 값과 다르면 접두어 없는 경로로 리다이렉트하는 데 쓰인다.
        public lang: string = "",
    ) {
        super();
    }

    public static create(model: Partial<ArticleModel>): ArticleModel {
        const article = createModel<ArticleModel>(ArticleModel, {
            ...model
        });

        // Blog Article의 경우 blogData에 파싱된 데이터 입력
        if (model.data && model.label && !['NEWS', 'EVENT'].includes(model.label)) {
            try {
                const parsedData = JSON.parse(model.data);
                article.blogData = BlogDataModel.create(parsedData);
            } catch (error) {
                // 파싱 실패 시 기본값 할당
                article.blogData = new BlogDataModel();
            }
        } else {
            article.blogData = new BlogDataModel();
        }

        // Event Article의 경우 eventData에 파싱된 데이터 입력
        if (model.data && model.label && ['EVENT'].includes(model.label)) {
            try {
                const parsedData = JSON.parse(model.data);
                article.eventData = EventDataModel.create(parsedData);
            } catch (error) {
                article.eventData = new EventDataModel();
            }
        } else {
            article.eventData = new EventDataModel();
        }

        return article;
    }
}
